export default function Feature({ text, isMobile }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: isMobile ? "center" : "flex-start",
        alignItems: "center",
        gap: 16,
      }}
    >
      <div
        style={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          background: "#C9A66B",
          flexShrink: 0,
        }}
      />

      <span
        style={{
          color: "#444",
          fontSize: isMobile ? 16 : 17,
          lineHeight: 1.7,
        }}
      >
        {text}
      </span>
    </div>
  );
}